<template>
  <div class="remote_set_balloon">
    <div class="md_header">
      <div class="set_modal_title no-drag">{{this.$t('rehabilitation.patient')}} {{ this.$t('RMC.device_setting') }}</div>
      <span class="md_close pointer" @click="closeSetModal">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" fill="none" viewBox="0 0 22 21">
          <path fill="#2A589F" fill-rule="evenodd" d="M21.267 1.294c.3-.286.312-.76.027-1.06-.285-.3-.76-.313-1.06-.028L11.02 8.96 2.28.22c-.293-.292-.767-.292-1.06 0-.293.294-.293.768 0 1.061l8.712 8.713-9.699 9.213c-.3.285-.312.76-.027 1.06.286.3.76.313 1.06.028l9.727-9.24 9.227 9.226c.293.293.767.293 1.06 0 .293-.293.293-.767 0-1.06l-9.2-9.2 9.187-8.726z" clip-rule="evenodd"/>
        </svg>
      </span>
    </div>
    <div class="table-container">
      <div
          class="item-parent"
          :style="lang() === 'ko' || lang() === 'zh-hk' ? 'height: 60px;' :' height: 80px;'"
      >
        <div
            class="item-title"
        >
          {{ this.$t('RMC.you_camera.title') }}
          <span
              class="edit_mode_btn"
              @click="handleClick"
          >
            <label class="patient_add pointer edit_patient_checkbox">
              <input
                  id="checkbox-deviceSetModal"
                  type="checkbox"
                  v-model="yourCameraLeftRight"
              />
              <label for="checkbox-deviceSetModal">
                <span/>
              </label>
            </label>
          </span>
        </div>
        <div>
          <span>
            {{ this.$t('RMC.you_camera.dec01') }}
          </span>
          <br/>
          <span>
            {{ this.$t('RMC.you_camera.dec02') }}
          </span>
        </div>
      </div>
      <hr style="width:100%; opacity: 0.6; margin-top: 15px;"/>
    </div>

    <div class="md_header">
      <div class="set_modal_title no-drag">{{ this.$t('RMC.device_setting') }}</div>
<!--      <span class="md_close pointer" @click="closeSetModal">-->
<!--        <img-->
<!--            src="/images/union.svg"-->
<!--            alt=""-->
<!--        >-->
<!--      </span>-->
    </div>
    <div v-if="browserAlertProps" style="display: flex;margin-bottom: 10px;width: 100%;">
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
           width="22" height="20"
           viewBox="0 0 172 172"
           style=" fill:#000000; margin-right: 5px;">
        <defs>
          <linearGradient x1="-1106.35775" y1="-1242.96517" x2="132.2465" y2="177.61508"
                          gradientUnits="userSpaceOnUse" id="color-1_hP6pCUyT8QGk_gr1">
            <stop offset="0" stop-color="#333333"></stop>
            <stop offset="1" stop-color="#feb705"></stop>
          </linearGradient>
          <radialGradient cx="65.17725" cy="60.13192" r="80.13408" gradientUnits="userSpaceOnUse"
                          id="color-2_hP6pCUyT8QGk_gr2">
            <stop offset="0" stop-color="#4b4b4b"></stop>
            <stop offset="0.531" stop-color="#393939"></stop>
            <stop offset="1" stop-color="#252525"></stop>
          </radialGradient>
        </defs>
        <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
           stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
           font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
          <path d="M0,172v-172h172v172z" fill="none"></path>
          <g>
            <path
                d="M159.9385,135.61483l-67.63183,-107.71142c0,0 -1.82033,-3.7625 -6.30667,-3.7625c-4.48633,0 -6.30667,3.7625 -6.30667,3.7625l-67.63183,107.71142c0,0 -1.3115,1.75942 -1.3115,4.13517c0,3.95958 3.20708,7.16667 7.16667,7.16667h136.16667c3.95958,0 7.16667,-3.20708 7.16667,-7.16667c0,-2.37575 -1.3115,-4.13517 -1.3115,-4.13517z"
                fill="url(#color-1_hP6pCUyT8QGk_gr1)"></path>
            <path
                d="M86.05017,132.58333c-2.623,0 -4.78733,-0.7955 -6.493,-2.3865c-1.70567,-1.591 -2.5585,-3.51525 -2.5585,-5.77992c0,-2.36142 0.86,-4.29642 2.58358,-5.805c1.72,-1.50858 3.87717,-2.26108 6.46792,-2.26108c2.623,0 4.773,0.76325 6.44283,2.28617c1.67342,1.5265 2.50833,3.45075 2.50833,5.77992c0,2.36142 -0.82775,4.31075 -2.48325,5.85158c-1.6555,1.54083 -3.81267,2.31483 -6.46792,2.31483zM94.01233,63.50025l-1.72358,43.62708c-0.05375,1.333 -1.15025,2.3865 -2.48325,2.3865h-7.80808c-1.33658,0 -2.43308,-1.05708 -2.48325,-2.39367l-1.63042,-43.6235c-0.05375,-1.40825 1.075,-2.58 2.48325,-2.58h11.16567c1.40825,0 2.537,1.17175 2.47967,2.58358z"
                fill="url(#color-2_hP6pCUyT8QGk_gr2)"></path>
          </g>
        </g>
      </svg>
      <span style="line-height: 1.5;">{{ browserAlertProps }}</span>
    </div>
    <SettingTable
        :deviceListProps="deviceListProps"
        :preSetDeviceIdProps="preSetDeviceIdProps"
        ref="settingTable"
    />
    <a
        class="btn blue btn_basics pointer no-drag"
        @click="completeSetting"
    >
      {{ this.$t('RMC.set_completed') }}
    </a>
  </div>
</template>
<script>
  import SettingTable from './remoteSetting/index';

  export default {
    name: 'DeviceSetModal',
    props: [
      'browserAlertProps',
      'deviceListProps',
      'preSetDeviceIdProps',
      'windowRefProps',
      'isIpadProps',
      'onTileClick',
      'yourCameraLeftRight',
      'yourElement',
    ],
    components: {SettingTable},
    data() {
      return {
        lang: () => {
          const language = navigator?.language || navigator?.userLanguage;
          const currentLang = localStorage.getItem('lang') ?? language;
          const korean = currentLang.includes('ko');
          const chinese = currentLang.includes('zh');
          const czech = currentLang.includes('cs');

          if (korean)
            return 'ko';
          // TODO: 중국어 운영 배포시 URL 체크 삭제
          else if (!window.location.href.includes('https://manager.rebless.clinic') && chinese)
            return 'zh-hk';
          // TODO: 체코어 운영 배포시 URL 체크 삭제
          else if (!window.location.href.includes('https://manager.rebless.clinic') && czech)
            return 'cs';
          else
            return 'en';
        },
        check: false
      }
    },
    methods: {
      closeSetModal() {
        this.$emit('closeSetModal');
      },
      completeSetting() {
        const {videoInputDeviceId, audioInputDeviceId, audioOutputDeviceId} = this.$refs.settingTable.getValue();

        const deviceIdValues = {
          videoInputDeviceId: videoInputDeviceId?.deviceId || '',
          audioInputDeviceId: audioInputDeviceId?.deviceId || '',
          audioOutputDeviceId: audioOutputDeviceId?.deviceId || ''
        };
        this.$emit('completeSetting', deviceIdValues);
      },
      handleClick(event) {
        event.stopPropagation();
        event.preventDefault();

        if (this.yourElement !== null)
          this.$emit('onTileClick');
      }
    }
  }
</script>